import { render, staticRenderFns } from "./match-card.vue?vue&type=template&id=362465e0&"
import script from "./match-card.vue?vue&type=script&lang=js&"
export * from "./match-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports